import { AppState } from 'store/rootReducer';

export const getNotifications = (state: AppState) => state.notifications;
